module.exports = __webpack_public_path__ + "static/12-e2186067915b2c4ccc15cfe30805bf78.png";